export default "__VITE_ASSET__Fpiw3lg7__"